<template>
  <app-content class="h-panel">
    <Tabs :datas="tabDatas" v-model="selected"></Tabs>
    <div class="h-panel-body padding">
      <component :is="selected" :account-sets-id="currentAccountSets.id"></component>
    </div>
  </app-content>
</template>

<script>
import InventoryCategory from './InventoryCategory'
import InventoryItem from './InventoryItem'
import InventoryRecord from './InventoryRecord'
import {mapState} from "vuex";

export default {
  name: "InventoryIndex",
  components: {InventoryCategory, InventoryItem, InventoryRecord},
  data() {
    return {
      tabDatas: [
        { title: '存货类别', key: 'InventoryCategory' },
        { title: '存货档案', key: 'InventoryItem' },
        { title: '出入库记录', key: 'InventoryRecord' }
      ],
      selected: 'InventoryCategory',
    };
  },
  computed: {
    ...mapState(["currentAccountSets"]),
  },
};
</script>
